import { AnyIfEmpty } from 'react-redux';
import {
    GET_LOCATION_UNITS_LIST_FAILURE,
    GET_LOCATION_UNITS_LIST_REQUEST,
    GET_LOCATION_UNITS_LIST_SUCCESS,
    GET_LOCATION_UNITS_LIST_APPEND,
    GET_LOCATION_UNITS_LIST_RESET,
} from '../constants/locationUnitsList.constants';

const initialState = {
    loading: false,
    data: [],
    count: 0,
    error: '',
};

const locationUnitsListReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_LOCATION_UNITS_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                // Don't clear data on request - only clear on reset or new search (handled by append flag)
            };

        case GET_LOCATION_UNITS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.data || [],
                count: action.payload?.count || 0,
                error: '',
            };

        case GET_LOCATION_UNITS_LIST_APPEND:
            // Append new data and deduplicate by id
            const existingData = state.data || [];
            const newData = action.payload?.data || [];
            const mergedData = [...existingData, ...newData];
            const uniqueData = mergedData.filter((obj, index, self) => index === self.findIndex((t) => t.id === obj.id));

            return {
                ...state,
                loading: false,
                data: uniqueData,
                count: action.payload?.count || state.count,
                error: '',
            };

        case GET_LOCATION_UNITS_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case GET_LOCATION_UNITS_LIST_RESET:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};

export default locationUnitsListReducer;

